import React from 'react';
import { FlaskConicalIcon, UploadIcon, AlertCircleIcon, LineChartIcon, TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
export const SmartLabs: React.FC = () => {
  return <div className="p-4 md:p-6 md:ml-64 pb-16 md:pb-6" data-id="element-730">
      <div className="mb-6" data-id="element-731">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-732">Smart Labs</h1>
        <p className="text-gray-600" data-id="element-733">Blutanalyse trifft KI</p>
      </div>
      {/* Upload Section */}
      <section className="mb-8" data-id="element-734">
        <div className="bg-white rounded-xl shadow-sm p-6 text-center" data-id="element-735">
          <div className="w-16 h-16 rounded-full bg-indigo-100 flex items-center justify-center mx-auto mb-4" data-id="element-736">
            <FlaskConicalIcon size={28} className="text-indigo-600" data-id="element-737" />
          </div>
          <h2 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-738">
            Lade deine Blutwerte hoch
          </h2>
          <p className="text-gray-600 mb-6 max-w-md mx-auto" data-id="element-739">
            Lade Laborberichte hoch oder gib deine Werte manuell ein. AYA
            analysiert diese und gibt dir personalisierte Empfehlungen.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-4" data-id="element-740">
            <button className="bg-indigo-600 text-white px-4 py-2 rounded-lg text-sm font-medium flex items-center justify-center" data-id="element-741">
              <UploadIcon size={18} className="mr-2" data-id="element-742" /> Laborbericht hochladen
            </button>
            <button className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg text-sm font-medium" data-id="element-743">
              Werte manuell eingeben
            </button>
          </div>
        </div>
      </section>
      {/* Latest Results */}
      <section className="mb-8" data-id="element-744">
        <div className="flex justify-between items-center mb-4" data-id="element-745">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-746">
            Deine neuesten Ergebnisse
          </h2>
          <span className="text-sm text-gray-500" data-id="element-747">
            Letzter Upload: vor 2 Wochen
          </span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-748">
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-749">
            <div className="flex items-center justify-between mb-3" data-id="element-750">
              <div className="flex items-center" data-id="element-751">
                <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center mr-3" data-id="element-752">
                  <AlertCircleIcon size={20} className="text-red-600" data-id="element-753" />
                </div>
                <div data-id="element-754">
                  <p className="font-medium text-gray-800" data-id="element-755">Vitamin D</p>
                  <p className="text-xs text-gray-500" data-id="element-756">25-OH-Vitamin D</p>
                </div>
              </div>
              <div className="text-right" data-id="element-757">
                <p className="font-semibold text-red-600" data-id="element-758">18 ng/ml</p>
                <p className="text-xs text-gray-500" data-id="element-759">Referenz: 30-80 ng/ml</p>
              </div>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2 mb-2" data-id="element-760">
              <div className="bg-red-500 h-2 rounded-full" style={{
              width: '30%'
            }} data-id="element-761"></div>
            </div>
            <p className="text-sm text-gray-600" data-id="element-762">
              <span className="font-medium text-red-600" data-id="element-763">Zu niedrig.</span>{' '}
              Vitamin D-Mangel kann dein Immunsystem und deine Knochengesundheit
              beeinträchtigen.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-764">
            <div className="flex items-center justify-between mb-3" data-id="element-765">
              <div className="flex items-center" data-id="element-766">
                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center mr-3" data-id="element-767">
                  <AlertCircleIcon size={20} className="text-orange-600" data-id="element-768" />
                </div>
                <div data-id="element-769">
                  <p className="font-medium text-gray-800" data-id="element-770">Magnesium</p>
                  <p className="text-xs text-gray-500" data-id="element-771">Serum-Magnesium</p>
                </div>
              </div>
              <div className="text-right" data-id="element-772">
                <p className="font-semibold text-orange-600" data-id="element-773">1.7 mg/dL</p>
                <p className="text-xs text-gray-500" data-id="element-774">Referenz: 1.8-2.6 mg/dL</p>
              </div>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2 mb-2" data-id="element-775">
              <div className="bg-orange-500 h-2 rounded-full" style={{
              width: '45%'
            }} data-id="element-776"></div>
            </div>
            <p className="text-sm text-gray-600" data-id="element-777">
              <span className="font-medium text-orange-600" data-id="element-778">
                Leicht niedrig.
              </span>{' '}
              Magnesium ist wichtig für Muskel- und Nervenfunktion sowie
              Energieproduktion.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-779">
            <div className="flex items-center justify-between mb-3" data-id="element-780">
              <div className="flex items-center" data-id="element-781">
                <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-782">
                  <LineChartIcon size={20} className="text-green-600" data-id="element-783" />
                </div>
                <div data-id="element-784">
                  <p className="font-medium text-gray-800" data-id="element-785">Omega-3 Index</p>
                  <p className="text-xs text-gray-500" data-id="element-786">EPA + DHA</p>
                </div>
              </div>
              <div className="text-right" data-id="element-787">
                <p className="font-semibold text-green-600" data-id="element-788">6.2%</p>
                <p className="text-xs text-gray-500" data-id="element-789">Referenz: {'>'}8%</p>
              </div>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2 mb-2" data-id="element-790">
              <div className="bg-green-500 h-2 rounded-full" style={{
              width: '70%'
            }} data-id="element-791"></div>
            </div>
            <p className="text-sm text-gray-600" data-id="element-792">
              <span className="font-medium text-green-600" data-id="element-793">
                Gut, aber verbesserungsfähig.
              </span>{' '}
              Erhöhe den Verzehr von fettem Fisch oder erwäge
              Omega-3-Supplemente.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-794">
            <div className="flex items-center justify-between mb-3" data-id="element-795">
              <div className="flex items-center" data-id="element-796">
                <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-797">
                  <LineChartIcon size={20} className="text-green-600" data-id="element-798" />
                </div>
                <div data-id="element-799">
                  <p className="font-medium text-gray-800" data-id="element-800">HbA1c</p>
                  <p className="text-xs text-gray-500" data-id="element-801">Langzeit-Blutzucker</p>
                </div>
              </div>
              <div className="text-right" data-id="element-802">
                <p className="font-semibold text-green-600" data-id="element-803">5.2%</p>
                <p className="text-xs text-gray-500" data-id="element-804">Referenz: 5.7%</p>
              </div>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2 mb-2" data-id="element-805">
              <div className="bg-green-500 h-2 rounded-full" style={{
              width: '85%'
            }} data-id="element-806"></div>
            </div>
            <p className="text-sm text-gray-600" data-id="element-807">
              <span className="font-medium text-green-600" data-id="element-808">Optimal.</span> Dein
              Langzeit-Blutzuckerwert ist im optimalen Bereich, was auf eine
              gute Stoffwechselgesundheit hindeutet.
            </p>
          </div>
        </div>
      </section>
      {/* Trends */}
      <section className="mb-8" data-id="element-809">
        <div className="flex justify-between items-center mb-4" data-id="element-810">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-811">
            Trends & Entwicklung
          </h2>
          <div className="flex space-x-2" data-id="element-812">
            <button className="text-purple-600 text-sm font-medium bg-purple-100 px-2 py-1 rounded" data-id="element-813">
              6 Monate
            </button>
            <button className="text-gray-600 text-sm font-medium bg-gray-100 px-2 py-1 rounded" data-id="element-814">
              1 Jahr
            </button>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-815">
          <div className="flex items-center mb-4" data-id="element-816">
            <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center mr-3" data-id="element-817">
              <TrendingUpIcon size={20} className="text-indigo-600" data-id="element-818" />
            </div>
            <p className="font-medium text-gray-800" data-id="element-819">Vitamin D - Entwicklung</p>
          </div>
          <div className="h-40 bg-gray-50 rounded-lg flex items-center justify-center mb-4" data-id="element-820">
            <p className="text-gray-400" data-id="element-821">Vitamin D Trend-Diagramm</p>
          </div>
          <div className="flex justify-between text-sm" data-id="element-822">
            <div data-id="element-823">
              <p className="text-gray-500" data-id="element-824">Vor 6 Monaten</p>
              <p className="font-medium text-gray-800" data-id="element-825">12 ng/ml</p>
            </div>
            <div data-id="element-826">
              <p className="text-gray-500" data-id="element-827">Vor 3 Monaten</p>
              <p className="font-medium text-gray-800" data-id="element-828">15 ng/ml</p>
            </div>
            <div data-id="element-829">
              <p className="text-gray-500" data-id="element-830">Aktuell</p>
              <p className="font-medium text-gray-800" data-id="element-831">18 ng/ml</p>
            </div>
            <div data-id="element-832">
              <p className="text-gray-500" data-id="element-833">Prognose</p>
              <p className="font-medium text-green-600" data-id="element-834">25 ng/ml</p>
            </div>
          </div>
        </div>
      </section>
      {/* Recommendations */}
      <section data-id="element-835">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-836">
          Personalisierte Empfehlungen
        </h2>
        <div className="space-y-4" data-id="element-837">
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-838">
            <div className="flex items-center mb-3" data-id="element-839">
              <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center mr-3" data-id="element-840">
                <TrendingUpIcon size={20} className="text-red-600" data-id="element-841" />
              </div>
              <div data-id="element-842">
                <p className="font-medium text-gray-800" data-id="element-843">
                  Vitamin D optimieren
                </p>
                <p className="text-xs text-gray-500" data-id="element-844">Höchste Priorität</p>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-3" data-id="element-845">
              Erhöhe deine Vitamin D-Supplementierung auf 5000 IE täglich für 8
              Wochen, dann erneut testen.
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-846">
              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-847">
                Vitamin D3 + K2
              </span>
              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-848">
                Täglich mit Fett einnehmen
              </span>
              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-849">
                Nachtest in 8 Wochen
              </span>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-850">
            <div className="flex items-center mb-3" data-id="element-851">
              <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center mr-3" data-id="element-852">
                <TrendingUpIcon size={20} className="text-orange-600" data-id="element-853" />
              </div>
              <div data-id="element-854">
                <p className="font-medium text-gray-800" data-id="element-855">Magnesium erhöhen</p>
                <p className="text-xs text-gray-500" data-id="element-856">Hohe Priorität</p>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-3" data-id="element-857">
              Supplementiere mit 300mg Magnesium Bisglycinat täglich,
              vorzugsweise abends.
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-858">
              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-859">
                Magnesium Bisglycinat
              </span>
              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-860">
                Abends einnehmen
              </span>
              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-861">
                Verbessert Schlaf
              </span>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-862">
            <div className="flex items-center mb-3" data-id="element-863">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-864">
                <TrendingUpIcon size={20} className="text-green-600" data-id="element-865" />
              </div>
              <div data-id="element-866">
                <p className="font-medium text-gray-800" data-id="element-867">Omega-3 verbessern</p>
                <p className="text-xs text-gray-500" data-id="element-868">Mittlere Priorität</p>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-3" data-id="element-869">
              Erhöhe die Zufuhr von Omega-3-Fettsäuren durch 2-3 Portionen
              fetten Fisch pro Woche oder ein hochwertiges Fischöl-Supplement.
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-870">
              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-871">
                Omega-3 Fischöl
              </span>
              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-872">
                2g EPA+DHA täglich
              </span>
              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-873">
                Mit Mahlzeit einnehmen
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>;
};